import React, { Fragment, useState } from "react";
import { Card } from "antd";
import { tabList } from "../Mantenedores/tabList";
import { useGetTable } from "../../../Hooks/Admin";

export const Editar = () => {
  const [activeTabKey, setActiveTabKey] = useState("Logros");
  const tableHook = useGetTable({ key: activeTabKey });

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  return (
    <Fragment>
      <Card
        style={{
          width: "100%",
        }}
        tabList={tabList}
        activeTabKey={activeTabKey}
        onTabChange={onTabChange}
        tabProps={{
          size: "small",
        }}
      >
        {activeTabKey && tableHook}
      </Card>
    </Fragment>
  );
};
